/**
 * 메인 루프 (research §1).
 * requestAnimationFrame → Clock가 게임 시간 전진 + 고정 스텝 수 결정 → 콜백 실행.
 */
import { MAX_FRAME_DT } from './Clock';

export type StepFn = () => void;
export type FrameFn = (dt: number) => void;

export class GameLoop {
  private raf = 0;
  private last = 0;
  private running = false;

  constructor(
    private clock: { advance(rawDt: number): number },
    private onStep: StepFn, // 고정 스텝 1회 (물리 등)
    private onFrame: FrameFn, // 프레임 1회 (렌더/시각, 가변 dt)
  ) {}

  start(): void {
    this.running = true;
    this.last = performance.now();
    this.raf = requestAnimationFrame(this.tick);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.raf);
  }

  private tick = (_frameTs: number): void => {
    if (!this.running) return;
    // rAF 타임스탬프는 start()의 performance.now()와 기준이 어긋날 수 있어(특히 첫 프레임이
    // 셰이더 컴파일 등으로 지연될 때 과거 시각이 옴) performance.now()로 시간 기반을 통일한다.
    const nowMs = performance.now();
    const rawDt = Math.max(0, (nowMs - this.last) / 1000);
    this.last = nowMs;

    const steps = this.clock.advance(rawDt);
    for (let i = 0; i < steps; i++) this.onStep();
    this.onFrame(Math.min(rawDt, MAX_FRAME_DT));

    this.raf = requestAnimationFrame(this.tick);
  };
}
